import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CcdlButtonComponent,
  CcdlInputComponent,
  ErrorConfig,
} from '@cpm-pr1618001/ng-design-lib';
import { Subscription } from 'rxjs';

@Component({
  selector: 'forgot-password-ui',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  imports: [ReactiveFormsModule, CcdlButtonComponent, CcdlInputComponent],
  standalone: true,
})
export class ForgotPasswordComponent implements OnInit, OnChanges, OnDestroy {
  @Input() fpForm!: FormGroup;
  @Input() isOTPRequested: boolean;

  @Output() resetPasswordSubmitEmitter: EventEmitter<void> =
    new EventEmitter<void>();

  @Output() requestOTPEmitter = new EventEmitter<string>();

  isResetTriggered: boolean = false;
  subscription: Subscription = new Subscription();
  emailErrorConfig: ErrorConfig = { invalid: 'Please enter valid email.' };
  resetErrorConfig: ErrorConfig = { invalid: 'OTP should be 6 digits.' };
  passwordErrorConfig: ErrorConfig = {
    invalid: 'Please enter valid password.',
  };
  confirmPasswordErrorConfig: ErrorConfig = {
    invalid: 'Please enter valid password.',
  };
  isValidOTP: boolean = false;
  requesteEmail: string;
  constructor() {}

  get resetOTPControl(): FormControl {
    return this.getControl('resetOTP');
  }

  get emailControl(): FormControl {
    return this.getControl('email');
  }
  ngOnInit(): void {
    this.subscription.add(
      this.resetOTPControl.valueChanges.subscribe((val: string) => {
        this.isValidOTP = true;
        if (val) {
          this.isValidOTP =
            this.resetOTPControl.valid && this.resetOTPControl.dirty;
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isOTPRequested?.currentValue && this.emailControl) {
      this.formatRequestedEmail();
    }
  }

  getControl(controlName: string): FormControl {
    return this.fpForm.get(controlName) as FormControl;
  }

  requestOTP(): void {
    if (this.emailControl.valid) {
      this.requestOTPEmitter.emit(this.emailControl.value);
    }
  }

  formatRequestedEmail(): void {
    this.requesteEmail;
    const email: string = this.emailControl.value || '';
    const atIndex: number = email.indexOf('@');
    this.requesteEmail = email.substring(atIndex - 3, email.length);
  }

  resetPasswordClick(): void {
    this.isResetTriggered = true;
    if (this.fpForm.valid) {
      this.resetPasswordSubmitEmitter.emit();
    }
  }

  ngOnDestroy(): void {}
}
